/**
 * handle を保存する理由とキー命名は recently-viewed.logic.ts の冒頭参照。
 */
import { LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { pushRecentlyViewedHandle } from '../algolia/recently-viewed.logic';

@customElement('kd-recently-viewed-tracker')
export class KdRecentlyViewedTracker extends LitElement {
  createRenderRoot() {
    return this;
  }

  @property({ type: String, attribute: 'product-handle' })
  productHandle = '';

  private _loaded = false;

  connectedCallback(): void {
    super.connectedCallback();
    // Shopify テーマエディタの再マウントによる二重 push を防ぐ。
    // productHandle が遅延セットされる経路でも蓄積が失われないよう、
    // 空チェックを通った時点で初めて _loaded を立てる。
    if (this._loaded) return;
    if (!this.productHandle) return;
    this._loaded = true;
    pushRecentlyViewedHandle(this.productHandle);
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-recently-viewed-tracker': KdRecentlyViewedTracker;
  }
}
